<template>
  <div class="choices">
    <draggable :list="list" handle=".c-grip" :animation="140" ghost-class="dz-ghost" tag="ol" class="clist">
      <li v-for="(choice, index) in list" :key="choice._k" :class="{ dup: duplicates.has(norm(choice.answer)) }">
        <span class="c-grip" aria-hidden="true"><VnIcon name="grip" /></span>
        <span class="mark" :class="kind === 'Multichoice' ? 'mk-box' : 'mk-dot'" aria-hidden="true" />
        <input :ref="'c' + index" v-model="choice.answer" :aria-label="`گزینه ${index + 1}`" maxlength="100" @keydown.enter.prevent="addAfter(index)" />
        <button type="button" class="c-del" title="حذف گزینه" @click="list.splice(index, 1)"><VnIcon name="x" /></button>
      </li>
    </draggable>
    <p v-if="duplicates.size" class="ins-error">گزینه‌ی تکراری دارید.</p>
    <div class="ins-row">
      <button type="button" class="ins-link" @click="addAfter(list.length - 1)"><VnIcon name="plus" />افزودن گزینه</button>
      <button type="button" class="ins-link" @click="bulkOpen = !bulkOpen">افزودن گروهی</button>
    </div>
    <div v-if="bulkOpen" class="bulk">
      <textarea v-model="bulk" rows="5" placeholder="هر گزینه در یک خط" />
      <button type="button" class="ins-btn" :disabled="!bulk.trim()" @click="addBulk">افزودن {{ fa(bulkLines.length) }} گزینه</button>
    </div>
    <p v-if="answered" class="ins-note">این پرسش پاسخ ثبت‌شده دارد؛ ویرایش متن یک گزینه، گزینه‌ی تازه می‌سازد تا پاسخ‌های قبلی معنای خود را نگه دارند.</p>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import VnIcon from '@/components/VnIcon/index.vue';
import { uid, fa } from '../designerModel';

const norm = value => String(value || '').trim();

export default {
  name: 'ChoiceEditor',
  components: { draggable, VnIcon },
  props: {
    list: { type: Array, required: true },
    kind: { type: String, required: true },
    answered: { type: Boolean, default: false },
  },
  data: () => ({ bulkOpen: false, bulk: '' }),
  computed: {
    duplicates() {
      const seen = new Set();
      const dups = new Set();
      this.list.forEach(choice => { const key = norm(choice.answer); if (key && seen.has(key)) dups.add(key); seen.add(key); });
      return dups;
    },
    bulkLines() { return this.bulk.split('\n').map(norm).filter(Boolean); },
  },
  methods: {
    fa, norm,
    addAfter(index) {
      this.list.splice(index + 1, 0, { id: null, _k: uid('c'), answer: '' });
      this.$nextTick(() => { const input = this.$refs['c' + (index + 1)]; if (input && input[0]) input[0].focus(); });
    },
    addBulk() {
      const existing = new Set(this.list.map(choice => norm(choice.answer)));
      this.bulkLines.filter(line => !existing.has(line)).forEach(line => { existing.add(line); this.list.push({ id: null, _k: uid('c'), answer: line }); });
      this.bulk = ''; this.bulkOpen = false;
    },
  },
};
</script>

<style scoped>
.choices { display: grid; gap: 8px; }
.clist { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }
.clist li { display: flex; align-items: center; gap: 6px; }
.c-grip { color: var(--text-4); cursor: grab; font-size: 13px; }
.mark { flex: none; width: 12px; height: 12px; border: 1.5px solid var(--text-3); }
.mark.mk-dot { border-radius: 50%; }
.mark.mk-box { border-radius: 2px; }
.clist input { flex: 1; min-width: 0; height: 36px; padding: 0 10px; border: 1px solid var(--line-strong); border-radius: var(--r-xs); background: var(--surface); font: inherit; font-size: 13px; color: var(--text); }
.clist input:focus { outline: none; border-color: var(--navy-900); box-shadow: 2px 2px 0 var(--teal-500); }
.clist li.dup input { border-color: var(--pink-500); background: var(--pink-50); }
.c-del { width: 30px; height: 30px; display: grid; place-items: center; border: 0; border-radius: var(--r-xs); background: transparent; color: var(--text-3); cursor: pointer; }
.c-del:hover { background: var(--pink-50); color: var(--pink-700); }
.c-del .vn-icon { width: 14px; height: 14px; }
.bulk { display: grid; gap: 8px; }
.bulk textarea { width: 100%; padding: 8px 10px; border: 1px solid var(--line-strong); border-radius: var(--r-xs); font: inherit; font-size: 13px; resize: vertical; }
</style>
